<ng-container *ngIf="addTaskButtonVisibility$ | async">
    <button mat-fab style="position: fixed; bottom:26px; right:26px;z-index:1000" [routerLink]="['/home/task']"
            (click)="navigateToCreateNewTask()"> <fa-icon [icon]="'plus'"></fa-icon>
    </button>

</ng-container>
